export enum ECardTab {
    DETAILS = 'DETAILS',
    COMMENTS = 'COMMENTS',
    ACTIVITY = 'ACTIVITY',
    TIMING = 'TIMING',
    RELATED = 'RELATED',
};
